export enum ActivityEnum {
  EVENT = 'EVENT',
  DONATION = 'DONATION',
  BUY_CHAPTER = 'BUY_CHAPTER',
  BUY_COIN = 'BUY_COIN',
  REDEEM = 'REDEEM',
  EXPIRED = 'EXPIRED',
  FORFEITED = 'FORFEITED',
}
